// Underline animation (only for desktop)
if (window.innerWidth > 1020) {
  //For the hover event
  const menus = document.querySelectorAll(".site-header-navigation .menu-wrapper");

  menus.forEach(menu => {
    underlineAnim(menu);
  });

  //For the focus event
  const menuItems = document.querySelectorAll(".site-header-navigation .menu-wrapper .level-0 > a");

  menuItems.forEach(menuItem => {
    underlineAnimFocus(menuItem);
  });
}

function underlineAnim(thisMenu) {
  thisMenu.addEventListener("mouseover", (event) => {
    // Check if target is only a link menu and not a WPML link menu (like lang selector)
    if (event.target.classList.contains("menu-link") && !event.target.parentElement.classList.contains("wpml-ls-item")) {
      thisMenu.style.setProperty(
        "--underline-width",
        `${event.target.offsetWidth}px`
      );
      thisMenu.style.setProperty(
        "--underline-offset-x",
        `${event.target.offsetLeft}px`
      );
    }
    document.activeElement.blur();
  });
  thisMenu.addEventListener("mouseleave", () =>
  thisMenu.style.setProperty("--underline-width", "0"));
}

function underlineAnimFocus(thisMenuItem) {
  thisMenuItem.addEventListener("focus", (event) => {
    // Check if target is only a link menu and not a WPML link menu (like lang selector)
    if (!event.target.parentElement.classList.contains("wpml-ls-item")) {
      thisMenuItem.parentNode.parentNode.style.setProperty(
        "--underline-width",
        `${event.target.offsetWidth}px`
      );
      thisMenuItem.parentNode.parentNode.style.setProperty(
        "--underline-offset-x",
        `${event.target.offsetLeft}px`
      );
    }
  });
  thisMenuItem.addEventListener("focusout", () =>
  thisMenuItem.parentNode.parentNode.style.setProperty("--underline-width", "0"));
}